import { render } from "./VideoFadeTab.vue?vue&type=template&id=143d92eb"
import script from "./VideoFadeTab.vue?vue&type=script&lang=js"
export * from "./VideoFadeTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__